module.exports = __webpack_public_path__ + "static/media/gal-13.212a1583.jpeg";